import { ServiceMenuListItem } from 'features/ServiceMenu/models';
import { useContext } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { ServiceMenuContext } from '../ServiceMenuListTable';
import ServiceMenuRow from '../ServiceMenuRow';

export interface ServiceMenuRowListProps {
  data: ServiceMenuListItem[];
}

function ServiceMenuRowList({ data }: ServiceMenuRowListProps) {
  const serviceMenuContext = useContext(ServiceMenuContext);

  return (
    <Droppable droppableId="root">
      {(provided, snapshot) => (
        <div
          {...provided.droppableProps}
          ref={provided.innerRef}
          style={serviceMenuContext.getListStyle(snapshot.isDraggingOver)}
        >
          {data.map((item, index) => (
            <ServiceMenuRow key={item.id} rowData={item} rowIndex={index} />
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default ServiceMenuRowList;
